import { LocalizationKeyTreeType } from "../keys";

export const de_DE: LocalizationKeyTreeType = {
	application: {
		brand: "MODUL-F",
		title: "Fachverfahrens-Editor",
		documentTitle: "MODUL-F Fachverfahrens-Editor",
		titleParts: {
			prefix: "Fachverfahrens",
			main: "Editor"
		},
		shortTitle: "Fachverfahrens-Editor",
		header: {
			title: {
				backTitle: "Zurück zum Start"
			},
			user: {
				title: "Nutzermenü öffnen",
				item: {
					user: { label: "Angemeldet als" },
					roles: {
						label: { single: "Rolle", multiple: "Rollen" },
						type: {
							admin: "Administrator:in",
							fv_admin: "FV-Administrator:in",
							fv_manager: "FV-Manager:in",
							fv_designer: "FV-Designer:in",
							none: "Keine"
						},
						composition: {
							client: "$role$ ($client$)"
						}
					},
					virtualScrolling: {
						label: "Virtuelles Scrollen",
						hint: "Diese Funktion ist nicht barrierefrei."
					}
				},
				button: { logout: { label: "Abmelden" } }
			},
			banner: {
				stage:
					"Sie befinden sich auf einer Abnahmeumgebung. " +
					"Bitte beachten Sie, dass diese Umgebung nicht für den produktiven Einsatz gedacht ist."
			},
			menu: {
				title: "Navigation öffnen",
				label: "Navigation"
			},
			info: {
				title: "Anwendungsinformation öffnen",
				version: { label: "Version" },
				documents: { label: "Unterlagen", accessibilityLabel: "Unterlagen öffnen (öffnet in neuem Tab)" },
				accessibility: { label: "Erklärung zur Barrierefreiheit" }
			}
		},
		view: {
			moduleMoveModal: {
				title: "Was wollen Sie tun?",
				description: {
					info: "Sie sind dabei das Modul „$modulName$“ im „$dockingPoint$“ zu ersetzen.",
					hint: "Hinweis: Beim Ersetzen können Einstellungen verloren gehen und Kind-Module werden gelöscht."
				},
				button: {
					append: "Als Kind einfügen",
					replace: "Ersetzen"
				}
			},
			noAccess: {
				button: { label: "Abmelden" },
				message:
					"Sie wurden erfolgreich angemeldet. " +
					"Jedoch sind Sie nicht berechtigt Fachverfahren oder Stammdatenlisten zu editieren. " +
					"Bitte kontaktieren Sie Ihre Administration."
			},
			accessibility: {
				title: "Erklärung zur Barrierefreiheit",
				button: { close: { title: "Modal schließen" } }
			},
			loginError: {
				button: { label: "Wiederholen" },
				message: "Sie konnten nicht angemeldet werden."
			},
			logout: {
				button: { label: "Anmelden" },
				message: "Sie wurden erfolgreich abgemeldet."
			},
			fachverfahrenOverview: {
				documentTitle: {
					FACHVERFAHREN: "Übersicht aller Fachverfahren",
					STAMMDATEN: "Übersicht aller Stammdatenlisten"
				},
				fachverfahrenKey: {
					description: {
						FACHVERFAHREN:
							"Vom System automatisch generierter Wert zur eindeutigen Identifikation des Fachverfahrens.",
						STAMMDATEN:
							"Vom System automatisch generierter Wert zur eindeutigen Identifikation der Stammdatenliste."
					}
				},
				preview: {
					title: "Vorschau öffnen"
				},
				internalApplication: {
					icon: {
						active: { title: "Interner Antrag als Link verfügbar" },
						inactive: { title: "Interner Antrag" }
					}
				},
				status: {
					job: {
						PREVIEW: { label: "In Verarbeitung" },
						PUBLISH: { label: "In Veröffentlichung" },
						UPDATE: { label: "In Veröffentlichung" },
						DELETE: { label: "In Löschung" }
					},
					lost: {
						description: {
							FACHVERFAHREN:
								"Es liegt keine Konfiguration für dieses im Fachverfahrens-Portal existierende Fachverfahren vor.",
							STAMMDATEN:
								"Es liegt keine Konfiguration für diese im Fachverfahrens-Portal existierende Stammdatenliste vor."
						}
					}
				},
				version: "$version$ ($editableVersion$)",
				rowAction: {
					open: {
						FACHVERFAHREN: "Fachverfahren öffnen",
						STAMMDATEN: "Stammdatenliste öffnen"
					}
				}
			},
			printTemplateOverview: {
				documentTitle: "Übersicht aller Dokumentenvorlagen",
				rowAction: { open: "Dokumentenvorlage öffnen" }
			},
			fachverfahrenTree: {
				title: {
					FACHVERFAHREN: "Fachverfahren",
					STAMMDATEN: "Stammdatenliste"
				},
				subtitle: {
					default: "$name$ ($version$)",
					new: {
						FACHVERFAHREN: "Neues Fachverfahren",
						STAMMDATEN: "Neue Stammdatenliste"
					}
				},
				rootNode: {
					FACHVERFAHREN: "Fachverfahren",
					STAMMDATEN: "Stammdatenliste"
				},
				module: {
					placeholder: "Kein Modul gewählt"
				},
				dockingPoint: {
					anonymous: "Modul auswählen",
					unknown: "Unbekannter Andockpunkt ($name$)"
				},
				button: {
					add: { title: "Modul hinzufügen" },
					close: {
						title: {
							FACHVERFAHREN: "Fachverfahren schließen",
							STAMMDATEN: "Stammdatenliste schließen"
						}
					}
				},
				contextMenu: {
					button: { title: "Modulmenü öffnen" },
					subHeader: "Verfügbare Module"
				},
				validationBar: {
					migration: {
						title: "Veraltete Module",
						description: {
							general: "Mindestens ein Modul muss aktualisiert werden.",
							autoMigrationPossible:
								"Mindestens ein Modul muss aktualisiert werden. " +
								"Einige Module können auch automatisch aktualisiert werden."
						},
						button: {
							migration: { title: "Alle möglichen Module automatisch aktualisieren." }
						}
					},
					readonly: {
						title: "Veröffentlichte Version",
						description: {
							FACHVERFAHREN:
								"Diese Version ist nicht mehr veränderbar. " +
								"Wechseln Sie in die Arbeitsversion, um das Fachverfahren zu bearbeiten.",
							STAMMDATEN:
								"Diese Version ist nicht mehr veränderbar. " +
								"Wechseln Sie in die Arbeitsversion, um die Stammdatenliste zu bearbeiten."
						},
						button: {
							switch: {
								label: "Arbeitsversion",
								title: "Wechsel zur Arbeitsversion."
							}
						}
					},
					deleting: {
						title: "Version wird gelöscht",
						description: {
							FACHVERFAHREN:
								"Diese Version des Fachverfahrens ist nicht mehr veränderbar und wird gerade gelöscht.",
							STAMMDATEN:
								"Diese Version der Stammdatenlisten ist nicht mehr veränderbar und wird gerade gelöscht."
						}
					}
				},
				tooltip: {
					remark: "Die mit einem * markierten Elemente sind verpflichtend.",
					deprecated: {
						unknown: "Das Modul ist unbekannt.",
						outdated: "Das Modul wurde weiterentwickelt. Bitte aktualisieren Sie die Modulkonfiguration.",
						discontinued:
							"Das Modul wird nicht mehr weiterentwickelt. " +
							"Bitte ersetzen Sie das Modul durch ein anderes."
					},
					invalid: { dockingPoint: "Das Modul befindet sich auf einem nicht existierenden Andockpunkt." },
					children: {
						error: "Mindestens eines der Submodule hat einen Fehler.",
						warning: "Mindestens eines der Submodule hat eine Warnung.",
						info: "Mindestens eines der Submodule hat einen Hinweis."
					}
				}
			},
			fachverfahrenSaveRequest: {
				publish: {
					title: {
						FACHVERFAHREN: "Fachverfahren veröffentlichen",
						STAMMDATEN: "Stammdatenliste veröffentlichen"
					},
					content: {
						FACHVERFAHREN: "Das Fachverfahren muss vor der Veröffentlichung gespeichert werden.",
						STAMMDATEN: "Die Stammdatenliste muss vor der Veröffentlichung gespeichert werden."
					},
					button: { submit: { label: "Speichern und veröffentlichen" } }
				},
				preview: {
					title: {
						FACHVERFAHREN: "Vorschau erstellen",
						STAMMDATEN: "Vorschau erstellen"
					},
					content: {
						FACHVERFAHREN: "Das Fachverfahren muss gespeichert werden, um die Vorschau zu erstellen.",
						STAMMDATEN: "Die Stammdatenliste muss gespeichert werden, um die Vorschau zu erstellen."
					},
					button: { submit: { label: "Speichern und Vorschau erstellen" } }
				}
			},
			forceLockRequest: {
				title: {
					FACHVERFAHREN: "Fachverfahren entsperren",
					STAMMDATEN: "Stammdatenliste entsperren",
					PRINT_TEMPLATE: "Dokumentenvorlage entsperren"
				},
				content: {
					FACHVERFAHREN:
						"Das Fachverfahren ist durch eine andere Nutzer:in gesperrt. " +
						"Sollten Sie für das Fachverfahren eine Entsperrung erzwingen und Änderungen speichern, " +
						"kann die andere Nutzer:in das Fachverfahren nicht mehr verlustfrei abspeichern.",
					STAMMDATEN:
						"Die Stammdatenliste ist durch eine andere Nutzer:in gesperrt. " +
						"Sollten Sie für die Stammdatenliste eine Entsperrung erzwingen und Änderungen speichern, " +
						"kann die andere Nutzer:in die Stammdatenliste nicht mehr verlustfrei abspeichern.",
					PRINT_TEMPLATE:
						"Die Dokumentenvorlage ist durch eine andere Nutzer:in gesperrt. " +
						"Sollten Sie für die Dokumentenvorlage eine Entsperrung erzwingen und Änderungen speichern, " +
						"kann die andere Nutzer:in die Dokumentenvorlage nicht mehr verlustfrei abspeichern."
				},
				button: { submit: { label: "Entsperren erzwingen" }, refresh: { label: "Aktualisieren" } }
			},
			fachverfahrenDeleteConfirmation: {
				delete: {
					title: {
						FACHVERFAHREN: "Löschen einer Version des Fachverfahrens",
						STAMMDATEN: "Löschen einer Version der Stammdatenliste"
					},
					content: {
						warning: "Die Löschung kann nicht rückgängig gemacht werden.",
						consequences: {
							headline: "Folgendes wird beim Löschen entfernt:",
							fachverfahren: {
								FACHVERFAHREN: "die Version des Fachverfahrens im Fachverfahrens-Editor",
								STAMMDATEN: "die Version der Stammdatenliste im Fachverfahrens-Editor"
							},
							versions: {
								FACHVERFAHREN:
									"die veröffentlichte Version des Fachverfahrens im Fachverfahrens-Portal",
								STAMMDATEN: "die veröffentlichte Version der Stammdatenliste im Fachverfahrens-Portal"
							},
							data: {
								FACHVERFAHREN:
									"alle mit dieser Version des Fachverfahrens erzeugten Anträge im Fachverfahrens-Portal",
								STAMMDATEN:
									"alle mit dieser Version der Stammdatenlisten erzeugten Einträge im Fachverfahrens-Portal"
							}
						},
						question: "Was wollen Sie tun?"
					},
					button: { delete: { label: "Version löschen" } }
				},
				deleteAll: {
					title: {
						FACHVERFAHREN: "Löschen aller Versionen des Fachverfahrens",
						STAMMDATEN: "Löschen aller Versionen der Stammdatenliste"
					},
					content: {
						warning: "Die Löschung kann nicht rückgängig gemacht werden.",
						consequences: {
							headline: "Folgendes wird beim Löschen entfernt:",
							fachverfahren: {
								FACHVERFAHREN:
									"alle Konfigurationsversionen des Fachverfahrens im Fachverfahrens-Editor",
								STAMMDATEN: "alle Konfigurationsversionen der Stammdatenliste im Fachverfahrens-Editor"
							},
							previews: {
								FACHVERFAHREN: "alle Vorschauen des Fachverfahrens",
								STAMMDATEN: "alle Vorschauen der Stammdatenliste"
							},
							versions: {
								FACHVERFAHREN:
									"alle veröffentlichten Versionen des Fachverfahrens im Fachverfahrens-Portal",
								STAMMDATEN:
									"alle veröffentlichten Versionen der Stammdatenliste im Fachverfahrens-Portal"
							},
							data: {
								FACHVERFAHREN:
									"alle mit diesem Fachverfahren erzeugten Anträge im Fachverfahrens-Portal",
								STAMMDATEN: "alle Einträge dieser Stammdatenliste im Fachverfahrens-Portal"
							}
						},
						question: "Was wollen Sie tun?"
					},
					button: { delete: { label: "Alle Versionen löschen" } }
				}
			},
			printTemplateDeleteConfirmation: {
				title: "Löschen der Dokumentenvorlage",
				content: {
					warning: "Die Löschung kann nicht rückgängig gemacht werden.",
					question: "Was wollen Sie tun?"
				},
				button: { delete: { label: "Löschen" } }
			},
			moduleRemoveConfirmation: {
				title: "Entfernen des Modules",
				message: "Wollen Sie wirklich das Modul entfernen?",
				button: { remove: { label: "Entfernen" } }
			},
			printTemplateRemoveConfirmation: {
				title: "Entfernen der Dokumentenvorlage",
				message: "Wollen Sie wirklich die Dokumentenvorlage entfernen?",
				button: { remove: { label: "Entfernen" } }
			},
			internalApplicationModal: {
				title: "Interner Antrag",
				content: {
					label: "Link zum internen Antrag",
					description: "Über den bereitgestellten Link können interne Nutzer:innen einen Antrag stellen.",
					notice:
						"Der angegebene Link ist nur für die Vorschau.\n" +
						"Den richtigen Link finden Sie bei der zuletzt veröffentlichten Version des Fachverfahrens.",
					personalLinksHint:
						"Für dieses Fachverfahren werden persönliche Links zum Formular versendet.\n" +
						"Diese können im Portal erstellt werden.",
					button: {
						copy: { icon: { title: "Link in Zwischenablage kopieren" } },
						close: { title: "Schließen" }
					}
				}
			},
			fachverfahrenPublishConfirmationForm: {
				thresholdMessage: {
					label: {
						info:
							"MODUL-F steht Ihnen im Paket „$tenantPackageType$“ zur Verfügung. " +
							"Mit diesem Paket können Sie $publicationThreshold$ Fachverfahren veröffentlichen.",
						warning:
							"Das Veröffentlichungslimit ist bald erreicht. " +
							"Wird das Limit erreicht, ist das Veröffentlichen nicht mehr möglich. " +
							"Sollen mehr Fachverfahren veröffentlicht werden, muss in ein höheres Paket gewechselt werden.",
						error:
							"Das Veröffentlichungslimit ist überschritten. " +
							"Aufgrund dessen kann kein Fachverfahren mehr veröffentlicht werden. " +
							"Sollen mehr Fachverfahren veröffentlicht werden, muss in ein höheres Paket gewechselt werden."
					},
					content: {
						info: "Bisherige Veröffentlichungen: $currentPublications$",
						warning: "Verbleibende Veröffentlichungen: $remainingPublications$"
					}
				}
			},
			moduleConfigurationForm: {
				global: {
					module: {
						text: "Dieser Konfigurationswert gilt für alle Module des selben Typs innerhalb eines Fachverfahrens."
					}
				},
				validationBar: {
					primary: "Veraltetes Modul",
					secondary:
						"Sie sehen die Konfiguration eines veralteten Moduls. Bitte aktualisieren Sie das Modul.",
					button: { migration: { title: "Modul aktualisieren" } }
				},
				externalEnumeration: {
					loading: "Liste wird geladen...",
					missing:
						"Aktuell kann dieser Wert nicht bearbeitet werden, " +
						"da die notwendigen Informationen nicht abgerufen werden konnten. " +
						"Bitte überprüfen Sie das Fachverfahren auf Fehler und beheben Sie diese.",
					fachverfahren: "$name$ ($key$, $version$)"
				},
				print: {
					name: {
						add: "Neue Dokumentenvorlage",
						edit: "Dokumentenvorlage bearbeiten (zuletzt am $date$ um $time$ Uhr)"
					},
					option: {
						add: "Neue Dokumentenvorlage",
						edit: "Bearbeiten",
						remove: "Entfernen"
					}
				},
				mapping: {
					outdatedWarning:
						"Das zuvor konfigurierte Feld existiert nicht mehr. " +
						"Wählen Sie erneut aus oder legen Sie ein neues Zielfeld an.",
					possiblyIncompatibleWarning:
						"Der Typ des Quellfelds ($sourceFieldType$) stimmt nicht mit dem des Zielfelds ($targetFieldType$) " +
						"überein. Die Daten werden daher in einem anderen Format als in der Quelldatei eingelesen.",
					repeatabilityWarning:
						"Die Wiederholbarkeit des Quellfeldes und der Zielfeldes passen nicht zusammen.",
					sourceRepeatMergeWarning:
						"Es ist nicht möglich Quellfelder aus derselben Wiederholbarkeit " +
						"auf mehrere Zielfelder in unterschiedlichen Wiederholbarkeiten zu mappen.",
					sourceRepeatSplitWarning:
						"Es ist nicht möglich mehrere Quellfelder in unterschiedlichen Wiederholbarkeiten " +
						"auf Zielfelder aus derselben Wiederholbarkeit zu mappen.",
					inaccuracyWarning: {
						fractionDigits:
							"Das Quell- und das Zielfeld haben unterschiedliche Einschränkungen der Nachkommastellen. Ggf. werden " +
							"Werte beim Einlesen der Daten so gerundet oder erweitert, dass sie zum Zielfeld passen."
					},
					fileUpload: {
						error: {
							message: {
								unprocessable:
									"Aus der hochgeladenen Datei konnten keine Pfade extrahiert werden, da keine eindeutige Auflösung von Abhängigkeiten möglich ist.",
								unknown: "Es konnten keine Quellfelder aus der hochgeladenen Datei ermittelt werden."
							},
							title: "Fehler beim extrahieren der Quellfelder"
						}
					},
					component: {
						fachverfahrenFieldsLoadingStatus: {
							info: "Das Laden der Fachverfahrensfelder ist noch nicht abgeschlossen.",
							warning:
								"Aktuell kann dieser Abschnitt nicht bearbeitet werden, " +
								"da die notwendigen Informationen nicht abgerufen werden konnten. " +
								"Bitte überprüfen Sie das Fachverfahren auf Fehler und beheben Sie diese.",
							empty:
								"Im aktuellen Fachverfahren sind keine gültigen Mapping-Felder vorhanden. " +
								"Fügen Sie geeignete Module hinzu, um Mapping-Felder bereitzustellen.",
							success: "Die aktuellen Fachverfahrensfelder stehen für das Mapping-Profil zur Verfügung."
						}
					}
				}
			},
			moduleSelectionModal: {
				title: "Modulauswahl",
				message: { noCandidates: "Keine passenden Module vorhanden" },
				button: { close: { title: "Modulauswahl schließen" } }
			},
			dockingPointSelectionModal: {
				title: "Positionsauswahl",
				description:
					"Das selektierte Modul passt auf mehrere Positionen des übergeordneten Moduls. " +
					"Bitte wählen Sie die gewünschte Position aus.",
				select: { label: "Position" },
				button: { close: { title: "Positionsauswahl schließen" }, selection: { label: "Auswählen" } }
			},
			fachverfahrenClientModal: {
				description: {
					new: {
						FACHVERFAHREN:
							"Bitte legen Sie die Zugehörigkeit für das neue Fachverfahren im Fachverfahrens-Editor fest. " +
							"Hierdurch ist das Fachverfahren nur noch für berechtigte Nutzer:innen sichtbar.",
						STAMMDATEN:
							"Bitte legen Sie die Zugehörigkeit für die neue Stammdatenliste im Fachverfahrens-Editor fest. " +
							"Hierdurch ist die Stammdatenliste nur noch für berechtigte Nutzer:innen sichtbar."
					},
					edit: {
						FACHVERFAHREN:
							"Die Zugehörigkeit des Fachverfahrens im Fachverfahrens-Editor kann festgelegt werden. " +
							"Hierdurch ist das Fachverfahren nur noch für berechtigte Nutzer:innen sichtbar.",
						STAMMDATEN:
							"Die Zugehörigkeit der Stammdatenliste im Fachverfahrens-Editor kann festgelegt werden. " +
							"Hierdurch ist die Stammdatenliste nur noch für berechtigte Nutzer:innen sichtbar."
					}
				}
			},
			printTemplateClientModal: {
				description: {
					new:
						"Bitte legen Sie die Zugehörigkeit für die neue Dokumentenvorlage im Fachverfahrens-Editor fest. " +
						"Hierdurch ist die Dokumentenvorlage nur noch für berechtigte Nutzer:innen sichtbar.",

					edit:
						"Die Zugehörigkeit der Dokumentenvorlage im Fachverfahrens-Editor kann festgelegt werden. " +
						"Hierdurch ist die Dokumentenvorlage nur noch für berechtigte Nutzer:innen sichtbar."
				}
			},
			moduleNameModal: {
				description:
					"Sie können den angezeigten Namen des Moduls im Modulbaum selbst festlegen. " +
					"Wenn Sie keine Angabe machen, wird der Name aus der Modulkonfiguration übernommen."
			},
			printTemplateNameModal: {
				description: "Sie können den angezeigten Namen der Dokumentenvorlage selbst festlegen."
			},
			printTemplateCreateModal: {
				title: "Dokumentenvorlage erstellen",
				input: {
					name: { label: "Name" }
				},
				button: {
					confirm: { label: "Erstellen" }
				}
			},
			printModelSelectionModal: {
				title: "Dokumentenvorlage erstellen",
				item: { internal: { label: '$name$ (Zugehörigkeit: "$client$")' } },
				button: {
					confirm: { label: "Erstellen" }
				}
			},
			printTemplateShareModal: {
				title: "Dokumentenvorlage teilen",
				input: {
					name: { label: "Name" }
				},
				button: {
					confirm: { label: "Teilen" }
				}
			},
			printModelEditor: {
				title: "Dokumentenvorlage",
				documentTitle: "Dokumentenvorlage bearbeiten",
				button: {
					fieldInformation: { label: "Feldinformationen" },
					close: { title: "Dokumentenvorlage schließen" }
				},
				modal: {
					edit: {
						title: "Bearbeitung der Dokumentenvorlage nicht verfügbar",
						message:
							"Die Bearbeitung der Dokumentenvorlage steht Ihnen aktuell nicht zur Verfügung. $details$"
					},
					save: {
						button: { forceSave: { label: "Speichern erzwingen" } }
					}
				}
			},
			moduleFieldTreePage: {
				title: "Feldinformationen",
				columns: {
					field: "Feld",
					path: "Pfad in Dokumentenvorlage",
					type: "Datentyp",
					values: "Werte"
				},
				rootNode: {
					FACHVERFAHREN: "Fachverfahren",
					STAMMDATEN: "Stammdatenliste"
				},
				button: { close: { title: "Fenster schließen" } }
			}
		},
		general: {
			fachverfahren: {
				module: { unknown: "Unbekanntes Modul ($moduleId$)" },
				key: {
					label: "Schlüssel: $key$"
				},
				version: {
					editable: { label: "Arbeitsversion" },
					label: "Version: $version$"
				},
				lock: {
					title: "Gesperrt",
					description: {
						general: {
							FACHVERFAHREN: "Seit unbestimmter Zeit ist dieses Fachverfahren in Benutzung.",
							STAMMDATEN: "Seit unbestimmter Zeit ist diese Stammdatenliste in Benutzung.",
							PRINT_TEMPLATE: "Seit unbestimmter Zeit ist diese Dokumentenvorlage in Benutzung."
						},
						specific: {
							FACHVERFAHREN:
								"Seit dem $date$ um $time$ Uhr hat $username$ dieses Fachverfahren in Benutzung.",
							STAMMDATEN:
								"Seit dem $date$ um $time$ Uhr hat $username$ diese Stammdatenliste in Benutzung.",
							PRINT_TEMPLATE:
								"Seit dem $date$ um $time$ Uhr hat $username$ diese Dokumentenvorlage in Benutzung."
						}
					},
					button: {
						unlock: {
							label: "Entsperren erzwingen"
						},
						refresh: {
							title: "Neu laden"
						}
					}
				},
				toast: {
					general: {
						FACHVERFAHREN: "Es bestehen Hinweise zum Fachverfahren.",
						STAMMDATEN: "Es bestehen Hinweise zu der Stammdatenliste“."
					},
					specific: {
						FACHVERFAHREN: "Es bestehen Hinweise zum Fachverfahren „$name$“.",
						STAMMDATEN: "Es bestehen Hinweise zu der Stammdatenliste „$name$“."
					},
					hints: {
						globalHints: {
							error: {
								FACHVERFAHREN: "Mindestens ein genereller Fehler besteht im Fachverfahren.",
								STAMMDATEN: "Mindestens ein genereller Fehler besteht in der Stammdatenliste."
							},
							warning: {
								FACHVERFAHREN: "Mindestens eine generelle Warnung besteht im Fachverfahren.",
								STAMMDATEN: "Mindestens eine generelle Warnung besteht in der Stammdatenliste."
							},
							info: {
								FACHVERFAHREN: "Mindestens eine generelle Information besteht im Fachverfahren.",
								STAMMDATEN: "Mindestens eine generelle Information besteht in der Stammdatenliste."
							}
						},
						entityRelatedHints: {
							error: "Mindestens ein Modul hat einen Fehler.",
							warning: "Mindestens ein Modul hat eine Warnung.",
							info: "Mindestens ein Modul hat eine Information."
						}
					},
					button: {
						openFachverfahren: {
							label: { FACHVERFAHREN: "Fachverfahren öffnen", STAMMDATEN: "Stammdatenliste öffnen" }
						},
						openPublish: { label: "Fachverfahrens-Portal öffnen" },
						openPreview: { label: "Vorschau öffnen" },
						openInternalApplication: { label: "Link zum internen Antrag „$name$“ öffnen" }
					}
				}
			},
			error: {
				title: {
					critical: "Kritischer Fehler",
					validation: {
						FACHVERFAHREN: "Fehler im Fachverfahren",
						STAMMDATEN: "Fehler in der Stammdatenliste"
					},
					save: {
						FACHVERFAHREN: "Fehler beim Speichern des Fachverfahrens",
						STAMMDATEN: "Fehler beim Speichern der Stammdatenliste",
						PRINT_TEMPLATE: "Fehler beim Speichern der Dokumentenvorlage"
					},
					share: {
						PRINT_TEMPLATE: "Fehler beim Teilen der Dokumentenvorlage"
					},
					import: {
						FACHVERFAHREN: "Fehler beim Importieren des Fachverfahrens",
						STAMMDATEN: "Fehler beim Importieren der Stammdatenliste"
					},
					copyInternalApplicationLink: "Fehler beim Kopieren des Links",
					action: "Aktion fehlgeschlagen"
				},
				message: {
					unknown: "Ein unbekannter Fehler ist aufgetreten.",
					popupBlocked:
						"Es konnte keine neues Fenster für die Feldinformation geöffnet werden. " +
						"Bitte erlauben Sie Popups für diese Seite.",
					missingResources:
						"Es ist nicht möglich diese Aktion in diesem Fachverfahrens-Editor auszuführen, " +
						"da notwendige Ressourcen nicht zur Verfügung stehen.",
					maliciousResources:
						"Die Verarbeitung der Anfrage ist nicht möglich, " +
						"da schädliche Inhalte in der Anfrage festgestellt wurden.",
					load: {
						general: {
							FACHVERFAHREN:
								"Fehler beim Laden des Fachverfahrens. " +
								"Bitte kontaktieren Sie die Ersteller:innen des Fachverfahrens.",
							STAMMDATEN:
								"Fehler beim Laden der Stammdatenliste. " +
								"Bitte kontaktieren Sie die Ersteller:innen der Stammdatenliste.",
							PRINT_TEMPLATE:
								"Fehler beim Laden der Dokumentenvorlage. " +
								"Bitte kontaktieren Sie die Ersteller:innen der Dokumentenvorlage."
						},
						readonly: {
							FACHVERFAHREN:
								"Das Fachverfahren wird gerade veröffentlicht oder ist bereits veröffentlicht. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
							STAMMDATEN:
								"Die Stammdatenliste wird gerade veröffentlicht oder ist bereits veröffentlicht. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
							PRINT_TEMPLATE:
								"Die Dokumentenvorlage ist schreibgeschützt. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut."
						},
						locked: {
							FACHVERFAHREN:
								"Das Fachverfahren ist durch eine andere Nutzer:in gesperrt. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
							STAMMDATEN:
								"Die Stammdatenliste ist durch eine andere Nutzer:in gesperrt. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
							PRINT_TEMPLATE:
								"Die Dokumentenvorlage ist durch eine andere Nutzer:in gesperrt. " +
								"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut."
						}
					},
					save: {
						general: {
							FACHVERFAHREN: "Fehler beim Speichern des Fachverfahrens.",
							STAMMDATEN: "Fehler beim Speichern der Stammdatenliste.",
							PRINT_TEMPLATE: "Fehler beim Speichern der Dokumentenvorlage."
						},
						readonly: {
							FACHVERFAHREN:
								"Das Fachverfahren kann nicht bearbeitet werden, da es bereits veröffentlicht ist.",
							STAMMDATEN:
								"Die Stammdatenliste kann nicht bearbeitet werden, da sie bereits veröffentlicht ist.",
							PRINT_TEMPLATE: "Die Dokumentenvorlage kann nicht bearbeitet werden."
						},
						outdated: {
							FACHVERFAHREN:
								"$username$ hat dieses Fachverfahren am $date$ um $time$ Uhr bearbeitet. " +
								"Beim Speichern wird der Arbeitsstand von $username$ überschrieben.",
							STAMMDATEN:
								"$username$ hat diese Stammdatenlist am $date$ um $time$ Uhr bearbeitet. " +
								"Beim Speichern wird der Arbeitsstand von $username$ überschrieben.",
							PRINT_TEMPLATE:
								"$username$ hat diese Dokumentenvorlage am $date$ um $time$ Uhr bearbeitet. " +
								"Beim Speichern wird der Arbeitsstand von $username$ überschrieben."
						},
						locked: {
							FACHVERFAHREN:
								"Das Fachverfahren kann nicht gespeichert werden, da es durch eine andere Nutzer:in gesperrt wurde. " +
								"Das Entsperren ermöglicht, mit dem letzten Arbeitsstand fortzufahren und das Fachverfahren zu speichern.",
							STAMMDATEN:
								"Die Stammdatenliste kann nicht gespeichert werden, da sie durch eine andere Nutzer:in gesperrt wurde. " +
								"Das Entsperren ermöglicht, mit dem letzten Arbeitsstand fortzufahren und die Stammdatenliste zu speichern.",
							PRINT_TEMPLATE:
								"Die Dokumentenvorlage kann nicht gespeichert werden, da sie durch eine andere Nutzer:in gesperrt wurde. " +
								"Das Entsperren ermöglicht, mit dem letzten Arbeitsstand fortzufahren und die Dokumentenvorlage zu speichern."
						}
					},
					share: {
						general: {
							PRINT_TEMPLATE: "Fehler beim Teilen der Dokumentenvorlage."
						}
					},
					delete: {
						single: {
							FACHVERFAHREN:
								"Fehler beim Löschen der Version $version$ des Fachverfahrens „$name$“. " +
								"Bitte versuchen Sie es später nochmal.",
							STAMMDATEN:
								"Fehler beim Löschen der Version $version$ der Stammdatenliste „$name$“. " +
								"Bitte versuchen Sie es später nochmal."
						},
						all: {
							FACHVERFAHREN:
								"Fehler beim Löschen des Fachverfahrens „$name$“. " +
								"Nicht alle Versionen konnten gelöscht werden. " +
								"Bitte versuchen Sie diese später nochmal zu löschen.",
							STAMMDATEN:
								"Fehler beim Löschen der Stammdatenlisten „$name$“. " +
								"Nicht alle Versionen konnten gelöscht werden. " +
								"Bitte versuchen Sie diese später nochmal zu löschen."
						}
					},
					loadWrongType: {
						FACHVERFAHREN: "Sie können keine Stammdatenliste als Fachverfahren importieren.",
						STAMMDATEN: "Sie können kein Fachverfahren als Stammdatenliste importieren."
					},
					preview: {
						FACHVERFAHREN: "Fehler beim Erstellen der Vorschau für das Fachverfahren „$name$“.",
						STAMMDATEN: "Fehler beim Erstellen der Vorschau für die Stammdatenliste „$name$“."
					},
					update: {
						FACHVERFAHREN: "Fehler beim Veröffentlichen der Änderungen des Fachverfahrens „$name$“.",
						STAMMDATEN: "Fehler beim Veröffentlichen der Änderungen der Stammdatenliste „$name$“."
					},
					publish: {
						FACHVERFAHREN: "Fehler beim Veröffentlichen der neuen Version des Fachverfahrens „$name$“.",
						STAMMDATEN: "Fehler beim Veröffentlichen der neuen Version der Stammdatenliste „$name$“."
					},
					publishThreshold: "Fehler beim Laden der Veröffentlichungsdaten.",
					import: {
						FACHVERFAHREN:
							"Es existieren Fehler im Fachverfahren. Bitte kontaktieren Sie die Ersteller:innen des Fachverfahrens.",
						STAMMDATEN:
							"Es existieren Fehler in der Stammdatenliste. Bitte kontaktieren Sie die Ersteller:innen der Stammdatenliste."
					},
					persistPrintModel: "Fehler beim Übernehmen der Dokumentenvorlage.",
					persistPortalClients: "Fehler beim Übernehmen der Konfiguration von Zugehörigkeiten.",
					loadModuleConfiguration: "Fehler beim Laden der Modulkonfiguration.",
					persistModuleConfiguration: "Fehler beim Übernehmen der Modulkonfiguration.",
					buildDocumentModelModuleFailures:
						"Mindestens ein anderes Modul enthält Fehler, " +
						"welche die Erstellung der Datenstruktur verhindern. " +
						"Korrigieren Sie diese zunächst um die Dokumentenvorlage bearbeiten zu können.",
					buildDocumentModel: "Fehler beim Erstellen der Datenstruktur.",
					loadPrintModel: "Fehler beim Laden der existierenden Dokumentenvorlage.",
					uploadingMappingSourceFile:
						"Fehler beim Hochladen der Quelldatei. " +
						"Bitte stellen Sie sicher, dass die Quelldatei im XML-Format vorliegt.",
					processingMappingSourceFile:
						"Fehler beim Verarbeiten der Quelldatei. Die Quellfelder konnten nicht ermittelt werden.",
					processingMappingSourceSelect:
						"Fehler beim Verarbeiten der Stammdatenliste. Bitte prüfen Sie die Stammdatenliste auf Fehler.",
					loadingStammdaten: "Fehler beim Laden der Stammdatenlisten.",
					initializationFailed: {
						main: "Bei der Initialisierung des Fachverfahrens-Editors sind Fehler aufgetreten.",
						documentPathsTree: "Bei der Initialisierung der Feldinformationen sind Fehler aufgetreten."
					},
					forceLockFailed: "Beim Entsperren ist ein Fehler aufgetreten.",
					copyInternalApplicationLink: "Der Link konnte nicht in die Zwischenablage kopiert werden.",
					restricted: {
						FACHVERFAHREN:
							"Sie haben keine Berechtigung auf das Fachverfahren zuzugreifen. " +
							"Womöglich wurde in der Zwischenzeit die Zugehörigkeit des Fachverfahrens durch eine andere Nutzer:in geändert.",
						STAMMDATEN:
							"Sie haben keine Berechtigung auf die Stammdatenliste zuzugreifen. " +
							"Womöglich wurde in der Zwischenzeit die Zugehörigkeit der Stammdatenliste durch eine andere Nutzer:in geändert.",
						PRINT_TEMPLATE:
							"Sie haben keine Berechtigung auf die Dokumentenvorlage zuzugreifen. " +
							"Womöglich wurde in der Zwischenzeit die Zugehörigkeit der Dokumentenvorlage durch eine andere Nutzer:in geändert."
					},
					readonly: {
						FACHVERFAHREN:
							"Das Fachverfahren „$name$“ wird gerade veröffentlicht oder ist bereits veröffentlicht. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
						STAMMDATEN:
							"Die Stammdatenliste „$name$“ wird gerade veröffentlicht oder ist bereits veröffentlicht. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
						PRINT_TEMPLATE:
							"Die Dokumentenvorlage „$name$“ ist schreibgeschützt. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut."
					},
					locked: {
						FACHVERFAHREN:
							"Das Fachverfahren „$name$“ ist durch eine andere Nutzer:in gesperrt. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
						STAMMDATEN:
							"Die Stammdatenliste „$name$“ ist durch eine andere Nutzer:in gesperrt. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut.",
						PRINT_TEMPLATE:
							"Die Dokumentenvorlage „$name$“ ist durch eine andere Nutzer:in gesperrt. " +
							"Bitte aktualisieren Sie die Anwendung und versuchen Sie es gegebenenfalls erneut."
					}
				},
				button: {
					label: {
						reload: "Neu laden",
						forceSave: "Speichern erzwingen und Änderungen überschreiben"
					}
				}
			},
			warning: {
				title: {
					validation: {
						FACHVERFAHREN: "Warnungen im Fachverfahren",
						STAMMDATEN: "Warnungen in der Stammdatenliste"
					},
					import: {
						FACHVERFAHREN: "Importieren mit Warnungen abgeschlossen",
						STAMMDATEN: "Importieren mit Warnungen abgeschlossen"
					},
					loadModuleConfiguration: "Modulkonfiguration ist unvollständig"
				},
				message: {
					import: {
						FACHVERFAHREN: "Es wurden Änderungen am Fachverfahren vorgenommen.",
						STAMMDATEN: "Es wurden Änderungen an der Stammdatenliste vorgenommen."
					},
					loadModuleConfiguration:
						"Beim Laden der Modulkonfiguration sind Probleme aufgetreten. " +
						"Die Modulkonfiguration wird daher nur unvollständig angezeigt."
				}
			},
			info: {
				title: {
					action: "Aktion ausgeführt",
					validation: {
						FACHVERFAHREN: "Hinweise im Fachverfahren",
						STAMMDATEN: "Hinweise in der Stammdatenliste"
					},
					import: {
						FACHVERFAHREN: "Importieren mit Hinweisen abgeschlossen",
						STAMMDATEN: "Importieren mit Hinweisen abgeschlossen"
					},
					loadModuleConfiguration: "Keine Konfigurationsansicht verfügbar"
				},
				message: {
					preview: {
						FACHVERFAHREN: "Die Vorschau für das Fachverfahren „$name$“ wird erstellt.",
						STAMMDATEN: "Die Vorschau für die Stammdatenlisten „$name$“ wird erstellt."
					},
					update: {
						FACHVERFAHREN: "Die Änderungen für das Fachverfahren „$name$“ werden veröffentlicht.",
						STAMMDATEN: "Die Änderungen für die Stammdatenliste „$name$“ werden veröffentlicht."
					},
					publish: {
						FACHVERFAHREN: "Die neue Version für das Fachverfahren „$name$“ wird veröffentlicht.",
						STAMMDATEN: "Die neue Version für die Stammdatenliste „$name$“ wird veröffentlicht."
					},
					delete: {
						single: {
							FACHVERFAHREN: "Die Version $version$ des Fachverfahrens „$name$“ wird gelöscht.",
							STAMMDATEN: "Die Version $version$ der Stammdatenliste „$name$“ wird gelöscht."
						},
						all: {
							FACHVERFAHREN: "Das Fachverfahren „$name$“ wird gelöscht.",
							STAMMDATEN: "Die Stammdatenliste „$name$“ wird gelöscht."
						}
					},
					import: {
						FACHVERFAHREN: "Es existieren Hinweise zum importierten Fachverfahren.",
						STAMMDATEN: "Es existieren Hinweise zu der importierten Stammdatenliste."
					},
					loadModuleConfiguration:
						"Die Konfigurationsansicht steht Ihnen für dieses Modul nicht zur Verfügung.",
					migration: {
						unknown: "Die Auswirkungen des Ersetzens sind unbekannt.",
						losingConfiguration: "Die Modulkonfiguration „$name$“ wurde angepasst und geht verloren.",
						losingSubModule: "Das Untermodul „$name$“ an der Position „$dockingPoint$“ geht verloren."
					}
				}
			},
			success: {
				title: {
					action: "Aktion erfolgreich",
					validation: {
						FACHVERFAHREN: "Keine Hinweise zum Fachverfahren",
						STAMMDATEN: "Keine Hinweise zur Stammdatenliste"
					}
				},
				message: {
					preview: {
						FACHVERFAHREN: "Die Vorschau für das Fachverfahren „$name$“ wurde erfolgreich erstellt.",
						STAMMDATEN: "Die Vorschau für die Stammdatenliste „$name$“ wurde erfolgreich erstellt."
					},
					update: {
						FACHVERFAHREN:
							"Die Änderungen für das Fachverfahren „$name$“ wurden erfolgreich veröffentlicht.",
						STAMMDATEN: "Die Änderungen für die Stammdatenliste „$name$“ wurden erfolgreich veröffentlicht."
					},
					publish: {
						FACHVERFAHREN:
							"Die neue Version für das Fachverfahren „$name$“ wurde erfolgreich veröffentlicht. " +
							"Eine neue Arbeitsversion ist verfügbar.",
						STAMMDATEN:
							"Die neue Version für die Stammdatenliste „$name$“ wurde erfolgreich veröffentlicht. " +
							"Eine neue Arbeitsversion ist verfügbar."
					},
					download: {
						FACHVERFAHREN: "Das Fachverfahren „$name$“ wurde heruntergeladen.",
						STAMMDATEN: "Die Stammdatenliste „$name$“ wurde heruntergeladen."
					},
					export: {
						FACHVERFAHREN: "Das Fachverfahren „$name$“ wurde exportiert.",
						STAMMDATEN: "Die Stammdatenliste „$name$“ wurde exportiert."
					},
					import: {
						FACHVERFAHREN: "Das Fachverfahren wurde importiert.",
						STAMMDATEN: "Die Stammdatenliste wurde importiert."
					},
					persist: {
						FACHVERFAHREN: "Das Speichern des Fachverfahrens wurde erfolgreich durchgeführt.",
						STAMMDATEN: "Das Speichern der Stammdatenliste wurde erfolgreich durchgeführt."
					},
					delete: {
						single: {
							FACHVERFAHREN:
								"Die Version $version$ des Fachverfahrens „$name$“ wurde erfolgreich gelöscht.",
							STAMMDATEN:
								"Die Version $version$ der Stammdatenliste „$name$“ wurde erfolgreich gelöscht.",
							PRINT_TEMPLATE: "Die Dokumentenvorlage „$name$“ wurde erfolgreich gelöscht."
						},
						all: {
							FACHVERFAHREN: "Das Fachverfahren „$name$“ wurde erfolgreich gelöscht.",
							STAMMDATEN: "Die Stammdatenliste „$name$“ wurde erfolgreich gelöscht."
						}
					},
					validate: {
						FACHVERFAHREN: "Das Fachverfahren weist keine Fehler auf.",
						STAMMDATEN: "Die Stammdatenliste weist keine Fehler auf."
					},
					copyInternalApplicationLink: "Der Link wurde in die Zwischenablage kopiert.",
					share: {
						PRINT_TEMPLATE: "Die Dokumentenvorlage wurde erfolgreich geteilt."
					}
				}
			}
		}
	},
	component: {
		errorBoundary: {
			report: { title: "Fehlerbericht" }
		},
		autocomplete: {
			hintTemplate: "$count$ von $total$ Optionen"
		},
		modal: {
			general: {
				button: { close: { title: "Modal schließen" } }
			},
			reload: {
				title: "Neuladen notwendig",
				message: "Es ist notwendig die Seite neu zu laden, um die Änderungen der Einstellungen zu übernehmen.",
				button: {
					reload: { label: "Neu laden" }
				}
			},
			logout: {
				title: "Abmelden",
				message:
					"Sie werden in allen offenen Tabs abgemeldet und nicht gespeicherte Änderungen gehen verloren.",
				caution: "Es gibt nicht gespeicherte Änderungen in diesem Tab.",
				button: {
					logout: { label: "Abmelden" }
				}
			},
			veto: {
				save: {
					title: "Nicht gespeicherte Änderungen",
					message: "Es gibt nicht gespeicherte Änderungen. Wie wollen Sie weiter verfahren?",
					button: {
						discard: { label: "Verwerfen" },
						commit: { label: "Speichern" }
					}
				},
				apply: {
					title: "Nicht übernommene Änderungen",
					message: "Es gibt nicht übernommene Änderungen. Wie wollen Sie weiter verfahren?",
					button: {
						discard: { label: "Verwerfen" },
						commit: { label: "Übernehmen" }
					}
				}
			},
			name: {
				title: {
					new: "Name festlegen",
					edit: "Name anpassen"
				},
				input: { label: "Name" },
				button: {
					confirm: {
						new: { label: "Weiter" },
						edit: { apply: { label: "Übernehmen" }, save: { label: "Speichern" } }
					}
				}
			},
			client: {
				title: {
					new: "Zugehörigkeit festlegen",
					edit: "Zugehörigkeit anpassen"
				},
				button: {
					confirm: {
						new: { label: "Weiter" },
						edit: { label: "Speichern" }
					}
				}
			}
		},
		button: {
			apply: { label: "Übernehmen" },
			save: { label: "Speichern" },
			close: { label: "Schließen" },
			cancel: { label: "Abbrechen" }
		},
		input: {
			clientSelection: {
				label: "Zugehörigkeit"
			},
			printTemplateSelection: {
				label: "Vorlage",
				groups: {
					system: {
						label: "MODUL-F Vorlagen",
						items: {
							default: { label: "Standardvorlage" },
							stammdaten: { label: "Standardvorlage Stammdaten" }
						}
					},
					printTemplate: { label: "Eigene Vorlagen" },
					fachverfahren: { label: "Fachverfahrensvorlagen" }
				}
			}
		},
		richTextEditor: {
			toolbar: {
				link: { title: "Link" },
				image: { title: "Bild einfügen" },
				horizontalRule: { title: "Trennlinie einfügen" }
			},
			modal: { url: { title: "URL setzen", input: { label: "URL" } } }
		}
	},
	general: {
		indication: {
			info: "Information",
			success: "Erfolgreich",
			important: "Wichtig",
			caution: "Achtung",
			warning: "Warnung",
			error: "Fehler"
		},
		type: {
			string: "Eingabefeld",
			StringType: "Eingabefeld",
			boolean: "Entscheidungsfeld",
			BooleanType: "Entscheidungsfeld",
			ConfirmType: "Entscheidungsfeld",
			enumeration: "Auswahlfeld",
			EnumerationType: "Auswahlfeld",
			date: "Datumsfeld",
			DateType: "Datumsfeld",
			TimeType: "Uhrzeitfeld",
			DateTimeType: "Zeitpunktsfeld",
			NumberType: "Zahlenfeld",
			AttachmentType: "Dateianhang"
		}
	},
	attachment: {
		error: {
			unknown: "Ein unbekannter Fehler ist aufgetreten.",
			internal: "Ein interner Fehler ist aufgetreten.",
			"not-found": "Die ausgewählte Datei kann nicht mehr gefunden werden.",
			security: "Keinen Zugriff auf die ausgewählte Datei.",
			"invalid-file": "Die angegebene Datei konnte nicht verarbeitet werden."
		}
	}
};
